/** Derive SSE URL from JSON chat endpoint. */
export function laikaStreamUrl(jsonChatUrl: string): string {
  const trimmed = jsonChatUrl.replace(/\/$/, '');
  if (trimmed.endsWith('/stream')) return trimmed;
  if (trimmed.endsWith('/v3')) return `${trimmed}/stream`;
  return `${trimmed}/stream`;
}
